import { getMypage } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import { withServiceErrorCapture } from '@musinsa/services-common-service-zod4';

import { type GetMyPageServiceResponse, MyPageResponseSchema } from './mypage.dto';

const transformApiResponseToServiceDto = async (): Promise<GetMyPageServiceResponse> => {
  const { data: apiData } = await getMypage();

  try {
    const validatedData = MyPageResponseSchema.parse(apiData);
    return validatedData;
  } catch (error) {
    console.error('@ERROR?', error);
    throw error;
  }
};

export const getMyPageService = withServiceErrorCapture(lazyPipe(transformApiResponseToServiceDto));
